$(document).ready(function(){
        $('.product-mobile-gallery').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding: '20px',
        });

        $('.complete-the-look').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            centerPadding: '0 60px 0 0',
            prevArrow: $('.prev-btn'),
            nextArrow: $('.next-btn'),
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
        $('.related-products-slider').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: true
                    }
                }
            ]
        });

    $('.open-product-popup').on('click', function (){
        $('.shops-popup-overlay').show();
    })
    $('.close-popup').on('click', function (){
        $('.shops-popup-overlay').hide();
    })
})
